export default function GeozonesViewDeleteController() {

  'ngInject';

}